import './TestNav.css'
import { Link } from 'react-router-dom'

export function TestNav ({title, time, fullTime, restrat}) {
    function formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs.toString().padStart(2, '0')}`;
    }

    const givePercent = (fullTime, currentTime) => {
        const percent = Math.floor((currentTime * 100) / fullTime)
        return `${percent}%`
    }


    
    return (
        <nav>
            <div className='progress' style={{width: givePercent(fullTime, time)}}></div>
            <div className='home'>
                <Link to='/'>Home</Link>
                {/* <Link to='/'>{givePercent(fullTime, time)}</Link> */}
            </div>
            <div className='title'>
                {title} minutes typing test
            </div>
            <div className='control'>
                <div className='time'>{formatTime(time)}</div>
                <div className='restart' onClick={restrat}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 256 256"
                    enableBackground="new 0 0 256 256"
                    xmlSpace="preserve"
                    >
                    <metadata>Svg Vector Icons : http://www.onlinewebfonts.com/icon</metadata>
                    <g>
                        <g>
                        <g>
                            <path
                            fill="#fff"
                            d="M120.2,10.2c-17.9,1.8-29.8,5-43.8,11.8c-48.3,23.3-74.9,77.3-64,129.9c7.4,35.7,31.2,66.4,64,82.3c37.2,18.1,81.9,15.3,116.2-7.4c49.8-32.9,67.4-96.6,41.5-150.3c-16.8-34.8-50.2-59.3-88.7-65.1C139.8,10.4,124.6,9.7,120.2,10.2z M139.4,70.1c10.9,2.1,21,7,28.2,13.7l1.8,1.7l2.8-2.4c1.5-1.3,5.2-4.8,8.2-7.8c3-3.1,5.7-5.5,5.9-5.5c0.3,0,0.5,10.5,0.5,23.3v23.3h-23.3c-12.9,0-23.3-0.2-23.3-0.3c0-0.2,3.6-4,8.1-8.6c4.4-4.6,8.1-8.6,8.1-8.9c0-1.1-5.7-5.3-10.1-7.4c-6.2-3.1-11-4.2-17.6-4.3c-10.9,0-19.7,3.7-27.7,11.6c-4.9,4.9-7.7,9-10.1,14.8l-1.2,2.9l-9.6,0.2c-11.2,0.2-10.5,0.7-8.1-6.6c5.5-16.8,18.6-30.6,35.3-37C116.4,69.3,129.6,68.2,139.4,70.1z M107.4,148.4l-8.4,8.2l3.7,2.8c11.7,8.8,24.8,11.1,38.2,6.6c10.5-3.5,20.2-12.7,24.3-23.1l1.1-2.8h9.7c7.6,0,9.6,0.2,9.6,0.7c0,1.5-2.9,9.3-5,13.4c-5.9,11.6-15.2,20.8-27,26.5c-10.1,5-13.7,5.8-25.7,5.8c-8.6-0.1-10.8-0.2-14.7-1.3c-8.2-2.3-16.5-6.9-25.4-14.2l-1.8-1.4l-8.4,8.6l-8.5,8.6v-23.3v-23.3h23.3h23.3L107.4,148.4z"
                            />
                        </g>
                        </g>
                    </g>
                </svg>

                </div>
            </div>
        </nav>
    )
}